import React from "react";

import styles from "./sass/Header.module.sass";

export default function HeaderSpacer() {
    return <div className={styles.spacer} />;
}
